import React from 'react';
import { props } from 'tcomb-react';
import Locale from '../domain/Locale';
import Currency from '../domain/Currency';
import Amount from '../domain/Amount';
import get_bundle from '../domain/get_bundle';
import MarkdownComponent from './MarkdownComponent';

@props({
  locale: Locale,
  currency: Currency
})
export default class CouponShipping extends React.Component {

  getCost() {
    return Amount.format(this.props.locale, this.props.currency, 0);
  }

  getDescription() {
    return get_bundle(this.props.locale).order.coupon.shipping.description;
  }

  render() {
    return (
      <span>
        {/*this.getCost()*/}
        <MarkdownComponent>{this.getDescription()}</MarkdownComponent>
      </span>
    );
  }
}


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/CouponShipping.js
 **/